import * as ApiHelpers from './api_helper';

const apiOrigin = `${process.env.REACT_APP_CLIENT_AUTHORITY}/api`

export const HACRepository = {
  CreateTempUser: (data) => ApiHelpers.api_call('POST', 'users/request_access', data, apiOrigin),
  GetListAdmins: (org_id) => ApiHelpers.api_call('GET', `users/admins?org_id=${org_id}`, null, apiOrigin)
};
